import modalService from '@/services/modal.service'
import React, { useEffect, useState } from 'react'
import './ContactPrimaryMenu.sass'
import { ReactComponent as PlusIcon2 } from '@/assets/icons/plus-icon-2.svg'

import { MenuBottom } from '@/components/SideMenu/components/MenuBottom/MenuBottom'
import CreateContactModal from '../../CreateContactModal/CreateContactModal'
import useRenderEvent from '@/core/hooks/useRenderEvent'
import contactsService from '@/app-domains/contacts/contacts.service'
import AddContactLabelModal from './AddcontactLabelModal/AddContactLabelModal'
import contactslabelsService from '@/app-domains/contactslabels/contactslabels.service'
import ContactLabelCard from './ContactLabelCard/ContactLabelCard'
import store from '@/core/store'
import commonsService from '@/services/commons.service'
import dropdownService from '@/components/DropdownMenu/dropdown.service'
import { ContactsDropdownMenu } from './ContactsDropdownMenu/ContactsDropdownMenu'

// eslint-disable-next-line
const ContactPrimaryMenu = (props) => {
  const [sideMenuHidden, setSideMenuHidden] = useState(false)
  const [renderToggle, setRenderToggle] = useState(false)
  const [labels, setLabels] = useState(Object.values(contactslabelsService.getAllStoredContactLabels()))
  const [menuOpened, setMenuOpened] = useState(false)
  // eslint-disable-next-line
  const [menuOpenedEvent, setMenuOpenedEvent] = useState(false)

  useRenderEvent(['SIDE_MENU:HIDE'], () => {
    setSideMenuHidden(true)
  })

  useRenderEvent(['SIDE_MENU:SHOW'], () => {
    setSideMenuHidden(false)
  })

  useRenderEvent(['CONTACT_LIST:UPDATED'], () => {
    setRenderToggle(!renderToggle)
  })

  useRenderEvent(['CONTACTLABEL_LIST:UPDATED'], (labelList) => {
    setLabels(labelList)
  })

  useEffect(async () => {
    await contactslabelsService.getAllContactLabels()
  }, [])

  function createContactButtonFunctionality () {
    return (
      modalService.open(<CreateContactModal type='new'/>, true)
    )
  }

  function getUserInfo () {
    const myInfo = store.getState().me.me
    return (
      <div className='user-info-container'>
        <div className='user-info-domain'>
          <span className='user-domain' title={myInfo.defaultdomain}>{myInfo.defaultdomain}</span>
        </div>
      </div>
    )
  }

  const toggleMenuOpen = (e) => {
    if (dropdownService.isOpenedForThisTarget(e)) {
      setMenuOpened(false)
      setMenuOpenedEvent(false)
      return dropdownService.close()
    }
    setMenuOpenedEvent(e)
    setMenuOpened(Date.now())
  }

  store.on('DROPDOWN:CLOSE', () => {
    setMenuOpened(false)
    setMenuOpenedEvent(false)
  })

  return (
    <><div className={`primary-menu ${sideMenuHidden ? 'hidden-menu' : 'mb-show-menu'}`} onClick={() => { setSideMenuHidden(true) }}>
      <div className="primary-menu-container">
        { commonsService.isMobile() && getUserInfo() }
        <div className="menu-top">
          <div className="menu-top-label">
            Contacts
          </div>
          <div className="menu-top-right">
            <div className='create-contact-button' onClick={createContactButtonFunctionality}>
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 6.5V9 6.5ZM14 9v2.5V9Zm0 0h2.5H14Zm0 0h-2.5H14ZM9.833 4.833a3.333 3.333 0 1 1-6.666 0 3.333 3.333 0 0 1 6.666 0v0ZM1.5 15.667a5 5 0 1 1 10 0v.833h-10v-.833Z" stroke="#374151" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </div>
            <div className="dropdown-menu" onClick={toggleMenuOpen}>
              { menuOpened && <ContactsDropdownMenu event={menuOpenedEvent}/> }
              <svg width="4" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2.167v.008M2 8v.008m0 5.825v.009M2 3a.833.833 0 1 1 0-1.667A.833.833 0 0 1 2 3Zm0 5.833a.833.833 0 1 1 0-1.666.833.833 0 0 1 0 1.666Zm0 5.834a.834.834 0 1 1 0-1.668.834.834 0 0 1 0 1.668Z" stroke="#374151" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </div>
          </div>
        </div>
        <div className="menu-content">
          <ul className='labels-group contacts'>
            <li onClick={() => contactsService.switchToAllContacts()}>
              <div className="label-left">
                <span className='label-icon'>
                  <svg width="12" height="13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M6.005 5.2A2.4 2.4 0 1 0 6.008.4a2.4 2.4 0 0 0-.003 4.8ZM.4 12.397a5.6 5.6 0 0 1 11.2.006L.4 12.397Z" fill="currentColor"/></svg>
                </span>
                <div className='label-text-div'>
                  <span className='label-text'>
                    All Contacts
                  </span>
                </div>
              </div>
              <div className="label-right">
                {contactsService.getContactsNumber()}
              </div>
            </li>
            <li onClick={() => contactsService.switchToRecentlyContactedContacts()}>
              <div className="label-left">
                <span className='label-icon'>
                  <svg width="12" height="11" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M10.683 3.236c.272.634.407 1.299.407 1.995 0 .697-.137 1.362-.41 1.996a5.19 5.19 0 0 1-1.099 1.64c-.46.46-1.007.825-1.64 1.097-.635.272-1.3.408-1.997.407a5.107 5.107 0 0 1-2.19-.486 5.027 5.027 0 0 1-1.766-1.37.24.24 0 0 1-.044-.151.198.198 0 0 1 .057-.138l.918-.923a.24.24 0 0 1 .168-.06c.071.009.122.035.154.08.325.424.725.753 1.198.985.473.232.975.349 1.506.35.465 0 .908-.09 1.33-.271.422-.18.787-.425 1.095-.733.308-.308.553-.673.734-1.094a3.34 3.34 0 0 0 .272-1.33 3.455 3.455 0 0 0-1.003-2.425 3.455 3.455 0 0 0-1.095-.733A3.34 3.34 0 0 0 5.95 1.8a3.4 3.4 0 0 0-2.33.916l.916.925c.138.134.17.288.094.462-.076.178-.208.268-.396.267l-3-.001a.412.412 0 0 1-.3-.128.412.412 0 0 1-.128-.301l.002-3c0-.188.09-.32.268-.395.174-.076.328-.044.462.094l.87.864A5.198 5.198 0 0 1 5.95.086c.696 0 1.362.137 1.995.41.634.272 1.18.638 1.64 1.098.46.46.826 1.008 1.098 1.642ZM6.805 3.3l-.001 3c0 .063-.02.114-.06.154a.209.209 0 0 1-.155.06H4.446a.209.209 0 0 1-.153-.06.209.209 0 0 1-.06-.155V5.87c0-.062.02-.113.06-.154.04-.04.091-.06.154-.06l1.5.001.001-2.357c0-.063.02-.114.06-.154.04-.04.092-.06.155-.06h.428c.063 0 .114.02.154.06.04.04.06.092.06.154Z" fill="currentColor"/></svg>
                </span>
                <div className='label-text-div'>
                  <span className='label-text'>
                    Recently Contacted
                  </span>
                </div>
              </div>
              <div className="label-right">
                {contactsService.getRecentlyContactedContactsNumber()}
              </div>
            </li>
            <li onClick={() => contactsService.switchToFrequentlyContactedContacts()}>
              <div className="label-left">
                <span className='label-icon'>
                  <svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M7 13.4A6.4 6.4 0 1 0 7.009.6a6.4 6.4 0 0 0-.007 12.8Zm.806-9.6a.8.8 0 1 0-1.6 0L6.204 7a.8.8 0 0 0 .235.565l2.26 2.265a.8.8 0 1 0 1.133-1.132L7.805 6.67 7.806 3.8Z" fill="currentColor"/></svg>
                </span>
                <div className='label-text-div'>
                  <span className='label-text'>
                    Frequently Contacted
                  </span>
                </div>
              </div>
              <div className="label-right">
                {contactsService.getFrequentlyContactedContactsNumber()}
              </div>
            </li>
          </ul>
          <div className="separator" />
          <div className="labels-top-container">
            <div className='labels-title'>Labels</div>
            <div className='labels-icon' onClick={() => modalService.open(<AddContactLabelModal type='add' />)} ><PlusIcon2/></div>
          </div>
          <ul className='labels-group second'>
            {labels.map((label, index) =>
              <ContactLabelCard key={index} label={label}/>)
              }
          </ul>
        </div>
      </div>
      <MenuBottom />
    </div>
      <div className={`side-menu-backdrop ${sideMenuHidden ? 'hidden' : ''}`} onClick={() => setSideMenuHidden(true)}></div>
    </>
  )
}

export default ContactPrimaryMenu
